import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, Typography, useTheme } from '@mui/material';
import SIcon from '../SIcon';
import useNavigationStyles from './useNavigationStyles';
const NavigationTile = ({ PrefixIcon, PostfixIcon, prefixIconcolor, prefixIconsize = 20, postfixIconcolor, postfixIconsize = 10, name = '', isSelected = false, onClick }) => {
    const theme = useTheme();
    const { navigationTileStyles, nameContainerStyles } = useNavigationStyles();
    return (_jsxs(Box, { className: 'navigation-tile', sx: {
            ...navigationTileStyles,
            background: isSelected
                ? alpha(theme.palette.primary.main, 0.12)
                : theme.palette.background.neutral
        }, onClick: onClick, children: [_jsxs(Box, { className: 'name-container', sx: nameContainerStyles, children: [PrefixIcon && (_jsx(SIcon, { Icon: PrefixIcon, size: prefixIconsize, color: isSelected ? theme.palette.primary.dark : prefixIconcolor })), _jsx(Typography, { variant: 'body1', color: isSelected ? theme.palette.primary.dark : theme.palette.text.primary, children: name })] }), PostfixIcon && _jsx(SIcon, { Icon: PostfixIcon, size: postfixIconsize, color: postfixIconcolor })] }));
};
export default NavigationTile;
